// extracted by mini-css-extract-plugin
export default {"container":"service-description-card_container__L10OI"};